import { usePhoneVerificationViewModel } from "@/features/auth/viewmodel/usePhoneVerificationViewModel";
import styles from "./PhoneVerificationPage.module.css";
import { Button } from "@/components/ui/Button";

export const PhoneVerificationForm = () => {
  const { otp, setOtp, handleVerify, error, handleResendOtp } = usePhoneVerificationViewModel();

  const otpArray = otp.split("").concat(Array(6).fill("")).slice(0, 6);

  const handleChange = (value: string, index: number) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otpArray];
    newOtp[index] = value;
    setOtp(newOtp.join(""));

    // move next
    if (value && index < 5) {
      const next = document.getElementById(`otp-${index + 1}`);
      next?.focus();
    }

    // move back
    if (!value && index > 0) {
      const prev = document.getElementById(`otp-${index - 1}`);
      prev?.focus();
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.card}>
        {/* 🔵 Top Info */}
        <div className={styles.infoBox}>Enter the OTP sent to your registered mobile number.</div>

        <div className={styles.icon}>📲</div>

        <h2>Verify Your Phone</h2>
        <p>We’ve sent a 6-digit verification code to your mobile number.</p>

        {/* 🔢 OTP BOXES */}
        <div className={styles.otpWrapper}>
          {otpArray.map((digit, i) => (
            <input
              key={i}
              id={`otp-${i}`}
              value={digit}
              onChange={(e) => handleChange(e.target.value, i)}
              maxLength={1}
              className={styles.otpInput}
            />
          ))}
        </div>

        {/* 🔁 Resend */}
        <p className={styles.resendRow}>
          Didn’t receive code?{" "}
          <span className={styles.resendAccent}>
            <Button className={styles.secondaryBtn} onClick={handleResendOtp}>
              Resend
            </Button>
          </span>
        </p>

        {error && <p className={styles.error}>{error}</p>}
        {/* ✅ Button */}
        <Button className={styles.primaryBtn} onClick={handleVerify}>
          Verify & Continue
        </Button>
      </div>
    </div>
  );
};
